import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Paginate = ({ pages, route, page }) => {
  const navigate = useNavigate();
  pages = parseInt(pages);
  page = parseInt(page);
  const prevPage = page - 1;
  const nextPage = page + 1;

  const showPrevButton = page > 1;
  const showNextButton = page < pages;

  const pageNumbers = [];

  if (pages <= 5) {
    // If total pages are less than or equal to 5, show all page numbers
    for (let i = 1; i <= pages; i++) {
      pageNumbers.push(i);
    }
  } else {
    // Always show the first page
    pageNumbers.push(1);

    // Show ellipsis before current page if current page is far enough from page 1
    if (page > 3) {
      pageNumbers.push("...");
    }

    if (page < pages) {
      for (let i = page - 1; i <= page + 1; i++) {
        if (i > 1) {
          pageNumbers.push(i);
        }
      }
    } else if (page === pages) {
      for (let i = pages - 1; i <= pages; i++) {
        pageNumbers.push(i);
      }
    }

    // Show ellipsis after current page if current page is far enough from the last page
    if (page < pages - 2) {
      pageNumbers.push("...");
    }

    // Always show the last page
    if (page + 1 < pages) {
      pageNumbers.push(pages);
    }
  }

  return (
    (
      <nav className="flex items-center justify-center" aria-label="Pagination">
        <div className="flex items-center space-x-2">
          {/* Previous Button */}
          {showPrevButton ? (
            <button
              onClick={() => navigate(`${route}page=${prevPage}`)}
              className="relative inline-flex items-center px-3 py-2 text-sm font-medium rounded-md border border-secondary/20 bg-white text-primary hover:bg-primary/5 transition-colors duration-200"
              aria-label="Previous page"
            >
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </button>
          ) : (
            <span
              className="relative inline-flex items-center px-3 py-2 text-sm font-medium rounded-md border border-secondary/10 bg-gray-50 text-gray-300 cursor-not-allowed"
              aria-disabled="true"
            >
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </span>
          )}

          {/* Page Numbers */}
          <div className="hidden md:flex space-x-2">
            {pageNumbers.map((num, index) => {
              if (num === "...") {
                return (
                  <span
                    key={`ellipsis-${index}`}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-secondary"
                  >
                    {num}
                  </span>
                );
              }

              return (
                <button
                  key={`page-${num}`}
                  onClick={() => navigate(`${route}page=${num}`)}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                    num === page
                      ? "bg-primary text-white border border-primary"
                      : "border border-secondary/20 bg-white text-primary hover:bg-primary/5"
                  }`}
                  aria-current={num === page ? "page" : undefined}
                >
                  {num}
                </button>
              );
            })}
          </div>

          {/* Mobile Page Indicator */}
          <span className="md:hidden text-sm text-secondary">
            Page {page} of {pages}
          </span>

          {/* Next Button */}
          {showNextButton ? (
            <button
              onClick={() => navigate(`${route}page=${nextPage}`)}
              className="relative inline-flex items-center px-3 py-2 text-sm font-medium rounded-md border border-secondary/20 bg-white text-primary hover:bg-primary/5 transition-colors duration-200"
              aria-label="Next page"
            >
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </button>
          ) : (
            <span
              className="relative inline-flex items-center px-3 py-2 text-sm font-medium rounded-md border border-secondary/10 bg-gray-50 text-gray-300 cursor-not-allowed"
              aria-disabled="true"
            >
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </span>
          )}
        </div>
      </nav>
    )
  );
};

export default Paginate;
